module.exports = __webpack_public_path__ + "static/media/EEDC.262b3f0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/EEDC.svg
// module id = 377
// module chunks = 25